import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/certificates`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/certificates`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/certificates/create`, parameters)
    },

    delete (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/certificates/delete`, parameters)
    },

    restore (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/certificates/restore`, parameters)
    },

    generatePdf (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/certificates/generatePdf`, parameters)
    },

    validate (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/certificates/validate`, parameters)
    },

    userCertificates (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/certificates/userCertificates`, parameters)
    },
}